import React, { useState } from "react";
import {
  Avatar,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import StyledLetterAvatar from "./StyledLetterAvatar";
import { useAuth } from "../../hooks/use-auth";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import HelpCenterOutlinedIcon from "@mui/icons-material/HelpCenterOutlined";

const StyledAvatarMenu = () => {
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const { logout } = useAuth();

  const logoutHandler = () => {
    logout();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Account settings">
        <IconButton
          onClick={handleClick}
          size="small"
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          {user?.img_url ? (
            <Avatar alt="user avatar" src={user?.img_url} />
          ) : (
            <StyledLetterAvatar
              name={`${user?.first_name} ${user?.last_name}`}
            />
          )}
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={() =>
            window.open(
              "https://doc.clickup.com/3654689/d/h/3fh11-15202/29807ec55e7ec0b",
              "_blank",
              "noopener,noreferrer"
            )
          }
        >
          <ListItemIcon>
            <HelpCenterOutlinedIcon fontSize="small" />
          </ListItemIcon>
          คู่มือการใช้งาน
        </MenuItem>
        <MenuItem onClick={logoutHandler}>
          <ListItemIcon>
            <FileUploadOutlinedIcon fontSize="small" />
          </ListItemIcon>
          ออกจากระบบ
        </MenuItem>
      </Menu>
    </>
  );
};

export default StyledAvatarMenu;
